"use strict";
/** @format */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSecureId = exports.generateId = void 0;
/**
 * Browser-friendly unique ID generator
 * Uses a combination of timestamp, random number, and counter for uniqueness
 */
let idCounter = 0;
const generateId = (prefix = 'hmf') => {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 8);
    const counter = (++idCounter).toString(36);
    return `${prefix}-${timestamp}-${randomPart}-${counter}`;
};
exports.generateId = generateId;
/**
 * Alternative implementation using crypto.getRandomValues if available
 * Falls back to Math.random if crypto is not available
 */
const generateSecureId = (prefix = 'hmf') => {
    const timestamp = Date.now().toString(36);
    let randomPart;
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        // Use crypto.getRandomValues for better randomness (available in modern browsers)
        const array = new Uint32Array(1);
        crypto.getRandomValues(array);
        randomPart = array[0].toString(36);
    }
    else {
        // Fallback to Math.random
        randomPart = Math.random().toString(36).substring(2, 8);
    }
    const counter = (++idCounter).toString(36);
    return `${prefix}-${timestamp}-${randomPart}-${counter}`;
};
exports.generateSecureId = generateSecureId;
//# sourceMappingURL=generateId.js.map